import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NodeDetailsDTO } from '../../../common/services/env-configuration/node-details.dto';
import { VERSION } from '../../../version';
import { EnvironmentService } from '../../../common/services/env-configuration/environment.service';

@Component({
  selector: 'app-admin-version',
  templateUrl: './admin-version.component.html',
  styleUrls: ['./admin-version.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
})
export class AdminVersionComponent implements OnInit {
  public nodeDetailsDTO: NodeDetailsDTO;
  public version: string = VERSION;
  constructor(private envService: EnvironmentService) {}

  ngOnInit(): void {
    this.getAdminVersion();
  }

  getAdminVersion(): void {
    this.envService.getNodeInfoObs().subscribe((details) => {
      this.nodeDetailsDTO = details;
    });
  }
}
